<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'子媒体列表'"
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div
        class="videoList-box"
        element-loading-text="导出中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!--操作栏-->
        <div class="action-bar">
          媒体类型:
          <el-input
            style="width:100px"
            :disabled="true"
            v-model="mediaTypeName"
            clearable
            size="small"
            class="param-input"
          ></el-input>
          媒体标题:
          <el-input
            :disabled="true"
            v-model="mediaTitle"
            clearable
            size="small"
            class="param-input"
          ></el-input>
          媒体Id:
          <el-input
            style="width:220px"
            :disabled="true"
            v-model="params.mId"
            clearable
            size="small"
            class="param-input"
          ></el-input>
          状态:
          <el-select v-model="params.isActive" placeholder="状态" size="small">
            <el-option
              v-for="item in isActives"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            size="small"
            @click="getSubMediaList('status')"
            >搜索</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="batchOverhead()"
            :disabled="isDisabled"
            >批量上架</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="batchTakeDown()"
            :disabled="isDisabled"
            >批量下架</el-button
          >
        </div>
        <!--数据表格-->
        <el-table
          :data="subTableData"
          style="width: 100%"
          border
          ref="multipleTable"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
          height="580"
        >
          <el-table-column
            type="selection"
            v-if="isSelection"
            width="55"
            fixed="left"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="子集Id"
            align="center"
            width="220"
          ></el-table-column>
          <el-table-column
            prop="episodeNumber"
            label="第几集"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="章节名"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="cover"
            label="封面图"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.cover">暂无封面图</span>
              <div
                v-else
                class="picturePreview"
              >
                <decrypt-img
                  style="width: 80px; height: 80px"
                  :src="imgUrl + scope.row.cover"
                  fit="fill"
                ></decrypt-img>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="listenPermission"
            label="类型"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-tag type="success" size="mini" effect="plain" class="tags">
                {{
                  scope.row.listenPermission === 0
                    ? "会员"
                    : scope.row.listenPermission === 1
                    ? "金币"
                    : scope.row.listenPermission === 2
                    ? "免费"
                    : "-"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isActive"
                @change="setStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格"
            align="center"
            width="80"
            :sortable="'custom'"
          ></el-table-column>
          <el-table-column
            prop="playTime"
            label="总时长"
            align="center"
            width="130"
            :sortable="'custom'"
          >
            <template slot-scope="scope">{{
              scope.row.playTime | changeSecond
            }}</template>
          </el-table-column>
          <el-table-column prop="url" label="预览" align="center" width="80">
            <template slot-scope="scope">
              <i
                class="el-icon-video-play views"
                title="点击预览"
                @click="checkMedia(scope.row, 'video')"
              ></i>
            </template>
          </el-table-column>
          <el-table-column
            prop="audioUrl"
            label="资源地址"
            align="center"
            width="200"
          >
            <template slot-scope="scope" v-if="scope.row.audioUrl">
              <audio-player
                ref="audioPlayer"
                :show-prev-button="false"
                :show-next-button="false"
                :show-volume-button="false"
                :audio-list="[$audUrl + '/' + scope.row.audioUrl]"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="urlSet" label="图集预览" align="center" width="100">
            <template slot-scope="scope">
              <div v-if="mediaType === 'image'" class="picturePreview" @click="previewPicture(scope.row.urlSet, scope.row.id)">
                <el-image style="width: 50px; height: 50px" :src="imgUrl + item" fit="fill"
                  v-for="(item, i) in scope.row.seriesCover" :key="i"></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="urlSet" label="小说预览" align="center" width="100">
            <template slot-scope="scope">
              <div v-if="mediaType === 'image'" class="picturePreview" @click="previewPicture(scope.row.urlSet, scope.row.id)">
                <el-image style="width: 50px; height: 50px" :src="imgUrl + item" fit="fill"
                  v-for="(item, i) in scope.row.seriesCover" :key="i"></el-image>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="size"
            label="帖子大小(M)"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.size ? scope.row.size / 1024 / 1024 : "-"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="150"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
              ></el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="removeVideo(scope.row.id)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="bottom">
          <!--批量上下架-->
          <div class="btn" v-if="isSelection">
            <el-button type="info" size="mini" @click="giveUp"
              >放弃操作</el-button
            >
            <el-button type="primary" size="mini" @click="subSection"
              >提交</el-button
            >
          </div>
          <div class="page">
            <el-pagination
              :page-sizes="[10, 25, 50, 100]"
              :current-page="params.pageNumber"
              :page-size="params.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
              v-if="total > 10"
              @size-change="changeSize"
              @current-change="changeCurrent"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 小说预览 -->
    <el-dialog
      :title="textPreviewTitle"
      :visible.sync="isTextPreview"
      width="800px"
      class="textPreviewDialog"
      :before-close="subClose"
    >
      <div class="textPreview">
        {{ textPreviewContent }}
      </div>
    </el-dialog>

    <!-- 漫画预览 -->
    <el-dialog
      :title="comicsPreviewTitle"
      :visible.sync="isComicsPreview"
      width="800px"
      class="comicsPreviewDialog"
      :before-close="subClose"
    >
      <div>
        <div class="comicsList" v-for="item in comicsPreviews" :key="item">
          <img-load :src="imgUrl + item"></img-load>
        </div>
      </div>
    </el-dialog>

    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--------------------子媒体编辑----------------------->
    <el-dialog
      :title="'子媒体编辑'"
      :visible.sync="subEdit"
      width="700px"
      :before-close="subHandleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="editParam"
        label-position="left"
        label-width="110px"
      >
        <div class="form-flex-box">
          <el-form-item label="章节名:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请谨慎修改数据"
              v-model="editParam.name"
              :disabled="editTitle"
            ></el-input>
            <el-button type="success" size="small" @click="editTitle = false"
              >修改</el-button
            >
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="第几集:" prop="coins">
            <el-input
              v-model.number="editParam.episodeNumber"
              size="small"
              placeholder="请输入第几集"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格:" prop="price">
            <el-input
              v-model.number="editParam.price"
              size="small"
              placeholder="请输入价格"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="状态:" prop="isActive">
            <el-select
              v-model.number="editParam.isActive"
              placeholder="请选择状态"
              size="small"
            >
              <el-option label="上架" :value="true"></el-option>
              <el-option label="下架" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型:" prop="listenPermission">
            <el-select
              v-model.number="editParam.listenPermission"
              placeholder="请选择类型"
              size="small"
            >
              <el-option label="会员" :value="0"></el-option>
              <el-option label="金币" :value="1"></el-option>
              <el-option label="免费" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          size="small"
          label="封面图:"
          prop="cover"
          style="width: 480px"
        >
          <base-upload
            :cover="editParam.cover"
            :action="action"
            @successCallback="uploadCover"
            :width="'120px'"
            :height="'120px'"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item
            style="width: 1100px"
            label="小说:"
            prop="cover"
            v-if="mediaType === 'text'"
          >
            <!--小说-->
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入小说内容"
              v-model="editParam.text"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 漫画 -->
        <div style="margin-bottom: 10px" v-if="mediaType === 'image'">
          漫画排序（<span style="color: red">拖拽修改排序顺序</span>）
          <base-upload
            :action="action"
            @successCallback="successCallbackAdd"
            :wSize="180"
            :hSize="320"
            :width="'100px'"
            :height="'50px'"
          ></base-upload>
        </div>
        <div class="form-flex-box" v-if="mediaType === 'image'">
          <div class="test_wrapper" @dragover="dragover($event)">
            <transition-group class="transition-wrapper" name="sort">
              <div
                class="comicsPreview"
                v-for="(item, i) in comics"
                :key="item"
                :a="item"
                :draggable="true"
                @dragstart="dragstart(item)"
                @dragenter="dragenter(item, $event)"
                @dragover="dragover($event)"
                @dragend="dragend(item, $event)"
              >
                <img-load
                  :width="'80px'"
                  :height="'100px'"
                  :src="imgUrl + item"
                ></img-load>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="deletePicture(i)"
                ></el-button>
              </div>
              <!-- <div v-for="(item) in dataList" :key='item.id' class="sort-item"
                :draggable="true"
                @dragstart="dragstart(item)"
                @dragenter="dragenter(item,$event)"
                @dragend="dragend(item,$event)"
                @dragover="dragover($event)"
                >
                  {{ item.label }}
                </div> -->
            </transition-group>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="subEdit = false" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
    <!--------------------子媒体批量上下架----------------------->
    <el-dialog
      :title="batchContent == 'delete' ? '批量删除' : '批量下架'"
      :visible.sync="isBatchDelete"
      width="1000px"
    >
      <el-table
        :data="videoIds"
        highlight-current-row
        border
        class="batchdelete"
      >
        <el-table-column
          prop="id"
          label="子集ID"
          align="center"
          width="220"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="mediaType"
          label="帖子类型"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <span>{{ mediaTypeName }}</span>
        </el-table-column>
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isActive === true">上架</span>
            <span v-if="scope.row.isActive === false">下架</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="章节"
          align="center"
          :show-overflow-tooltip="true"
          width="250"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.episodeNumber || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="章节名"
          align="center"
          :show-overflow-tooltip="true"
          width="250"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name || "-" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBatechDel">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmSubmit"
          :loading="isBatchDeleteLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import MediaPopup from "@/components/media-popup";
import baseConfig from "@/utils/serverUrlConfig";
import { sortEscape } from "@/utils/global";
import API from "@/api";
import { getTypeLabel } from "../../../../config";
import { animeKinds } from "../../../../config/anime";
export default {
  data() {
    return {
      dialogVisible: false,
      imgUrl: baseConfig.imgUrl,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      loading: false,
      // 子列表数据
      subTableData: [],
      total: "",
      time: "",
      // 请求列表查询
      mediaTitle: "",
      mediaType: "",
      mediaTypeName: "",
      params: {
        pageNumber: 1,
        pageSize: 10,
        isActive: undefined,
        mId: "",
      },
      isSelection: false,
      isDisabled: false,
      batchContent: "", // 批量操作的内容
      videoIds: [],
      isBatchDelete: false,
      isBatchDeleteLoading: false,
      isActives: [
        {
          label: "上架",
          value: true,
        },
        {
          label: "下架",
          value: false,
        },
        {
          label: "全部状态",
          value: undefined,
        },
      ],
      zones: [
        {
          label: "最新",
          value: "最新",
        },
        {
          label: "精选",
          value: "精选",
        },
        {
          label: "动漫",
          value: "动漫",
        },
        {
          label: "漫画",
          value: "漫画",
        },
        {
          label: "COS",
          value: "COS",
        },
        {
          label: "真人",
          value: "真人",
        },
        {
          label: "小说",
          value: "小说",
        },
        {
          label: "写真",
          value: "写真",
        },
        {
          label: "原作",
          value: "原作",
        },
      ],
      mediaTopics: [],

      // 编辑
      editParam: {
        id: "",
        episodeNumber: undefined,
        listenPermission: undefined,
        price: undefined,
        name: "",
        text: "",
        md5: "",
        videoUrl: "",
        urlSet: [],
        isActive: undefined,
        cover: undefined, // 封面图
      },
      editTitle: true,
      subEdit: false,
      flag: false,

      // 小说预览
      isTextPreview: false,
      textPreviewTitle: "",
      textPreviewContent: "",

      // 漫画预览
      isComicsPreview: false,
      comicsPreviews: [],
      comicsPreviewTitle: "",
      oldData: {},
      newData: {},
      comics: [],
    };
  },
  components: {
    MediaPopup,
  },
  methods: {
    // 新增图片上传成功回调
    successCallbackAdd(res) {
      this.comics.push(res.data.coverImg);
    },
    // 删除某张图片
    deletePicture(i) {
      if (this.comics.length === 1) {
        this.$message.error("请至少保留一张！");
        return;
      }
      this.comics.splice(i, 1);
    },
    // 获取视频列表
    getSubMediaList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getAnimeContentList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.subTableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.subTableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.subTableData = [];
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getSubMediaList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getSubMediaList();
    },
    // 编辑回调监听
    handlerVideoList() {
      this.getSubMediaList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getSubMediaList();
    },
    handlerPreviewList() {
      this.getSubMediaList();
    },
    cancelBatechDel() {
      this.isBatchDelete = false;
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.subTableData));
      objArr.forEach((item) => {
        this.subTableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    subSection() {
      if (this.videoIds.length == 0) {
        this.$message.error("请至少选择一条数据");
        return;
      }
      if (
        this.batchContent === "overhead" ||
        this.batchContent === "takeDown"
      ) {
        this.isBatchDelete = true;
      } else {
        this.dialogVisible = true;
      }
    },
    confirmSubmit() {
      if (this.batchContent == "overhead") {
        this.confirmOverhead();
        return;
      }
      this.confirmTakeDown();
    },
    // 确认批量下架
    async confirmTakeDown() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        isActive: false,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.setSubMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "下架成功",
          type: "success",
        });
        this.giveUp();
        this.getSubMediaList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    // 确认批量上架
    async confirmOverhead() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        isActive: true,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.setSubMediaStatus(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "上架成功",
          type: "success",
        });
        this.giveUp();
        this.getSubMediaList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    // 批量下架
    batchTakeDown() {
      this.batchContent = "takeDown";
      this.isSelection = true;
      this.isDisabled = true;
    },
    // 批量上架
    batchOverhead() {
      this.batchContent = "overhead";
      this.isSelection = true;
      this.isDisabled = true;
    },
    giveUp() {
      this.batchContent = "";
      this.isDisabled = false;
      this.isSelection = false;
      this.isBatchDelete = false;
      this.videoIds = [];
    },
    // 查看媒体
    checkMedia(row, type) {
      if (this.mediaType === "video" || this.mediaType === "video_adv") {
        this.$refs.mediaPopup.open(row.videoUrl, type);
      } else if (this.mediaType === "image") {
        this.comicsPreviewTitle = row.name;
        this.comicsPreviews = row.urlSet;
        this.isComicsPreview = true;
      } else if (this.mediaType === "text") {
        this.textPreviewTitle = row.name;
        this.textPreviewContent = row.text;
        this.isTextPreview = true;
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.params.mId = data.id;
      this.mediaType = data.mediaType;
      this.mediaTitle = data.title;
      const kind  = animeKinds.find(v => v.value == data.kind) 
      if (kind) {
        this.mediaTypeName = kind.label
      }
      // if (data.mediaType === "video") {
      //   this.mediaTypeName = "视频";
      // } else if (data.mediaType === "image") {
      //   this.mediaTypeName = "漫画";
      // } else if (data.mediaType === "text") {
      //   this.mediaTypeName = "小说";
      // }
      this.getSubMediaList();
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.mediaType = "";
      this.mediaTitle = "";
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        isActive: undefined,
        mId: "",
      };
      this.subEdit = false;
      this.editTitle = true;
      this.editParam = {};
      this.editParam = {
        id: "",
        episodeNumber: undefined,
        listenPermission: undefined,
        price: undefined,
        name: "",
        text: "",
        md5: "",
        videoUrl: "",
        urlSet: [],
        isActive: undefined,
        cover: undefined,
      };
    },

    subClose() {
      this.isTextPreview = false;
      this.textPreviewTitle = "";
      this.textPreviewContent = "";
      this.isComicsPreview = false;
      this.comicsPreviews = [];
      this.comicsPreviewTitle = "";
    },

    subHandleClose() {
      this.subEdit = false;
      this.editTitle = true;
      this.editParam = {
        id: "",
        episodeNumber: undefined,
        listenPermission: undefined,
        price: undefined,
        name: "",
        text: "",
        md5: "",
        videoUrl: "",
        urlSet: [],
        isActive: undefined,
      };
      this.comics = [];
      this.$refs.form.resetFields();
    },
    // 删除视频
    removeVideo(id) {
      this.$confirm("您确定要删除当前媒体吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.delAnimeContent({
          id: id,
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getSubMediaList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 编辑视频
    edit(row) {
      this.subEdit = true;
      this.editParam.id = row.id;
      this.editParam.mediaID = row.mediaID;
      this.editParam.episodeNumber = row.episodeNumber;
      this.editParam.listenPermission = row.listenPermission;
      this.editParam.price = row.price;
      this.editParam.name = row.name;
      this.editParam.text = row.text;
      this.editParam.videoUrl = row.videoUrl;
      this.editParam.urlSet = row.urlSet;
      this.editParam.height = row.height;
      this.editParam.weight = row.weight;
      this.editParam.mediaSize = row.mediaSize;
      this.editParam.playTime = row.playTime;
      this.editParam.status = row.status;
      this.editParam.isActive = row.isActive;
      this.editParam.cover = row.cover;
      this.comics = row.urlSet;
      // console.log(this.comics)
    },
    // 关闭窗口
    // close() {
    //   this.dialogVisible = false;
    //   this.mediaType = "";
    //   this.mediaTitle = "";
    //   this.params = {};
    // },
    //更新子媒体状态
    setStatus(row) {
      row.isActive = !row.isActive;
      let text = row.isActive ? "您确定要下架吗？" : "您确定要上架吗？";
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.id,
          isActive: !row.isActive,
        };
        API.updateAnimeContent(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.getSubMediaList();
            } else {
              this.$message.error("操作失败！");
            }
            this.flag = false;
            this.getSubMediaList();
          })
          .catch(() => {
            this.flag = false;
          });
      });
    },

    // 提交验证
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.editVideo();
        } else {
          this.flag = false;
          return false;
        }
      });
    },

    // 编辑
    editVideo() {
      if (this.mediaType == "image") {
        this.editParam.urlSet = [...this.comics];
        // console.log(this.editParam)
      }
      API.updateAnimeContent(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.handlerVideoList();
          } else {
            this.$message.error("编辑失败！");
          }
          this.flag = false;
          this.subHandleClose();
        })
        .catch(() => {
          this.flag = false;
          this.subHandleClose();
        });
    },

    // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover(e) {
      e.preventDefault();
    },

    dragstart(value) {
      this.oldData = value;
    },

    // 记录移动过程中信息
    dragenter(value, e) {
      this.newData = value;
      e.preventDefault();
    },

    // 拖拽最终操作
    dragend() {
      if (this.oldData !== this.newData) {
        let oldIndex = this.comics.indexOf(this.oldData);
        let newIndex = this.comics.indexOf(this.newData);
        let newItems = [...this.comics];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldData);
        this.comics = [...newItems];
      }
      // console.log(this.comics)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    // 封面图上传成功
    uploadCover(res) {
      this.editParam.cover = res.data.coverImg;
    },
  },
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}

.textPreviewDialog {
  /deep/ .el-dialog__body {
    max-height: 600px;
    overflow-y: auto;
  }
  // max-height: 800px;
  .textPreview {
    white-space: pre-wrap;
  }
}
.comicsPreviewDialog {
  /deep/ .el-dialog__body {
    max-height: 700px;
    overflow-y: auto;
  }
}

.videoList-box {
  // min-height: 100vh;
  min-height: 500px;
  overflow-y: auto;
}

.bottom {
  margin-top: 20px;

  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.el-pagination {
  margin-top: 0 !important;
}

.dialog-footer {
  left: 0;
}

.tagBox {
  display: inline-block;
  margin-right: 5px;
}

.test_wrapper {
  width: 100%;
  // display: flex;
  .transition-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .comicsPreview {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>
